import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_CONFIG_ADMIN = 'SET_CONFIG_ADMIN';
export const LOADING_CONFIG = 'LOADING_CONFIG';
export const ERROR_CONFIG = 'ERROR_CONFIG';

const setConfigAdmin = payload => ({ type: SET_CONFIG_ADMIN, payload });

export const setConfig = payload => {
    return dispatch => {
        return db.ref(`${Constants.CONFIG}`).once("value")
        .then((snapshot) => {
            if(snapshot.exists() && snapshot.val() !== null) {
                var config = snapshot.val();
                dispatch(setConfigAdmin(config));
            } else {
                console.log("getConfig not found: " + null);
                dispatch(setConfigAdmin(null));
            }
        })
        .catch(() => {
            console.log("getConfig not found: " + null);
            dispatch(setConfigAdmin(null));
        });
    };
};